const toItem = (option) => {
  const item = {
    groupId: option.grupoId,
    optionId: option.opcionId,
    inactive: option.deshabilitado,
    parameterId: option.parametroId,
    padre: option.padre,
    name: option.descripcion,
    value: option.valor,
    label: option.descripcion,
    id: option.opcionId
  };
  try {
    return { ...item, ...{ extra: JSON.parse(option.extra) } };
  } catch (e) {
    console.error('error', option, e);
  }
  return item;
};
const fromItem = (option) => ({
  grupoId: option.groupId,
  opcionId: option.optionId,
  parametroId: option.parameterId,
  padre: option.padre,
  descripcion: option.name,
  valor: option.value,
  deshabilitado: option.inactive,
  extra: JSON.stringify(option.extra || {})
});

export default {
  methods: {
    toItem,
    fromItem,
    optionToTree(options = [], maxLevelNode = 999) {
      const getNodesChild = (parentId = null) => {
        if (!parentId) {
          return options.filter((value) => !value.padre).map(toItem);
        }
        return options.filter((value) => value.padre === parentId).map(toItem);
      };
      const loadChildren = (optionItem, levelNode = 0) => {
        const option = optionItem;
        const level = levelNode + 1;
        if (level <= maxLevelNode) {
          option.levelNode = level;
          option.children = getNodesChild(option.optionId);
          if (!!option.children && option.children.length > 0) {
            option.isFolder = true;
            option.children.forEach((optionChild) => loadChildren(optionChild, level));
          } else {
            option.isFolder = !!option.extra?.isFolder;
          }
        }
      };
      const root = getNodesChild();
      root.forEach((optionChild) => loadChildren(optionChild, 0));
      return root;
    },
    filterTree(treeChildren, text) {
      const lowerText = text.toLowerCase();
      const matchesNode = (node) => {
        if (node.name.toLowerCase().includes(lowerText)) return true;
        const params = node.extra && node.extra.parameters;
        if (Array.isArray(params)) {
          return params.some(
            (p) => (p.parameter_id && p.parameter_id.toLowerCase().includes(lowerText))
              || (p.name && p.name.toLowerCase().includes(lowerText))
          );
        }
        return false;
      };
      const getNodes = (result, object) => {
        const arrayOptions = { ...object };
        if (Array.isArray(arrayOptions.children)) {
          arrayOptions.children = arrayOptions.children.reduce(getNodes, []);
        }
        if (
          (!!arrayOptions.children && arrayOptions.children.length > 0)
          || matchesNode(arrayOptions)
        ) {
          result.push(arrayOptions);
        }
        return result;
      };
      return treeChildren.reduce(getNodes, []);
    },
    optionChildrenToList(firstParentId, options = []) {
      const listReturn = [];
      const getNodesChild = (parentId = null) => {
        if (!parentId) {
          return options.filter((value) => value.padre === firstParentId).map(toItem);
        }
        return options.filter((value) => value.padre === parentId).map(toItem);
      };
      const loadChildren = (optionItem, levelNode = 0) => {
        const option = optionItem;
        const level = levelNode + 1;
        option.levelNode = level;
        option.children = getNodesChild(option.optionId);
        option.children.forEach((optionChild) => {
          listReturn.push(optionChild);
          loadChildren(optionChild, level);
        });
      };
      const root = getNodesChild();
      root.forEach((optionChild) => {
        listReturn.push(optionChild);
        loadChildren(optionChild, 0);
      });
      return listReturn;
    },
  }
};
